export const TOGGLE_MENU = 'APP::TOGGLE_MENU';
export const CLOSE_MENU = 'APP::CLOSE_MENU';

export function toggleMenu() {
    return {
        type: TOGGLE_MENU
    };
}

export function closeMenu() {
    return {
        type: CLOSE_MENU
    };
}



// WEBPACK FOOTER //
// ./src/data/actions/app.js